import { readable } from 'svelte/store';
export var isDark = readable(typeof window !== 'undefined'
    ? matchMedia('(prefers-color-scheme: dark)').matches
    : undefined, function (set) {
    if (typeof window !== 'undefined') {
        matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) { return set(e.matches); });
    }
});
